import React from "react";
import {Dropdown, Menu} from "antd";
import {EllipsisOutlined} from "@ant-design/icons";
import {NOOP} from "../../../../utils/NOOP.jsx";

export const columns = (onEdit = NOOP) => [
    {
        title: "#",
        key: "#",
        width: 50,
        render(_, __, idx) {
            return `${idx + 1}`;
        }
    },
    {
        title: "מזהה נהג",
        key: "driverId",
        render(_, {driverId}) {
            return driverId;
        }
    },
    {
        title: "שם נהג",
        key: "name",
        render(_, {name}) {
            return name;
        }
    },
    {
        title: "טלפון",
        key: "phone",
        render(_, {phone}) {
            return phone;
        }
    },
    {
        title: "מייל",
        key: "email",
        render(_, {email}) {
            return email;
        }
    },
    {
        title: "מספר תעודת זהות",
        key: "idNumber",
        render(_, {idNumber}) {
            return idNumber;
        }
    },
    {
        title: "מספר רכב",
        key: "licenseNumber",
        render(_, {licenseNumber}) {
            return licenseNumber;
        }
    },
    {
        render(_, deliveryProviderDriver) {
            return (
                <div>
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => onEdit(deliveryProviderDriver)}>עריכת ספק שילוח</Menu.Item>
                            </Menu>
                        }
                        trigger={["click"]}>
                        <EllipsisOutlined className="admin-orders-order-action-button" />
                    </Dropdown>
                </div>
            );
        }
    }
];
